module.exports = __webpack_public_path__ + "static/media/IMG_7033.d58ae0f4.jpg";